import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { useMonitorStatusFilterPickerItems } from "@certn/monitoring";

export function MonitoringStatusFilter() {
  const { clearParam, setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const options = useMonitorStatusFilterPickerItems();

  return (
    <Picker
      label={t("Monitoring status")}
      showActionBar
      selectionMode="single"
      selectedKeys={params.monitor_status?.split(",") || ["ACTIVE"]}
      onSelectionChange={(keys) => {
        clearParam("page");
        setParam("monitor_status", Array.from(keys));
      }}
      items={options}
      testID="monitoring-status-filter-picker"
    />
  );
}
